var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "12", height: "12", viewBox: "0 0 12 12", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "g",
      { clipPath: "url(#svg758905106a)" },
      React.createElement("path", { d: "M11.688 10.203L6.982 5.498 1.485 0h-.43L.968.223C.736.81.638 1.413.682 1.963c.05.627.288 1.17.688 1.57l4.292 4.292.566-.566 3.968 4.436a1.065 1.065 0 0 0 1.492 0 1.056 1.056 0 0 0 0-1.492zM3.673 6.83l-3.36 3.362a1.056 1.056 0 0 0 0 1.492c.39.39 1.066.425 1.491 0l3.361-3.361L3.673 6.83zM11.49 1.998L9.584 3.905l-.498-.498 1.907-1.906-.498-.498L8.59 2.91l-.498-.498L9.998.506 9.501.008 7.014 2.495a1.756 1.756 0 0 0-.512 1.138 1.013 1.013 0 0 1-.072.317l1.616 1.616c.101-.04.208-.066.317-.072.43-.026.834-.207 1.138-.512l2.487-2.487-.498-.497z" })
    ),
    React.createElement(
      "defs",
      null,
      React.createElement(
        "clipPath",
        { id: "svg758905106a" },
        React.createElement("path", { fill: "#fff", d: "M0 0h12v12H0z" })
      )
    )
  );
});